import { render, staticRenderFns } from "./StageBreadcrumbs.vue?vue&type=template&id=505e5712&scoped=true"
import script from "./StageBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./StageBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e5712",
  null
  
)

export default component.exports